import { v4 as uuid } from 'uuid';
const uuidKey = 'uuid';
const setUniqueUser = () => {
    if (!window.localStorage)
        return null;
    const uniqueUser = uuid();
    localStorage.setItem(uuidKey, uniqueUser);
    return uniqueUser;
};
const getUniqueUser = () => {
    if (!window.localStorage)
        return null;
    const user = localStorage.getItem(uuidKey);
    if (user)
        return user;
    else
        setUniqueUser();
};
export { getUniqueUser };
